import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PageType } from "talos-careers-page-library";
import { RouteReservedPrefixes } from "../constants/route-reserved-prefix";
import { PageModel, SiteConfig } from "../models/site.config.models";

@Injectable()
export class DynamicPageService {
  private homepageRoute = '/';

  constructor(
    private router: Router,
  ) { }

  // This is doing a lot but refactoring it would take more effort than it's worth. It's good to have this in one blob for testing.
  public tryGetPage(siteConfig: SiteConfig, pages: PageModel[], url: string): PageModel | null {
    const formattedUrl = url.includes("?")
      ? url.substring(0, url.indexOf('?'))
      : url;


    const page = formattedUrl === '/'
      ? this.tryGetHomepage(pages)
      : this.tryGetPageFromRoute(siteConfig, pages, formattedUrl);

    if (page) {
      return page;
    }

    // If it fails to get a page then it checks to see if the route is excluded from being automatically redirected
    if (RouteReservedPrefixes.some(excludedRoute => url.includes(excludedRoute))) {
      return null;
    }

    // If for some reason there's no page with the url "/" in the database for the client, then it will throw an error to stop an infinite loop
    if (url === this.homepageRoute) {
      console.error('No page was found with the url "/". Contact your administrator if this problem continues');
      return null;
    }

    // Automatically redirects the user to "/" so that it renders the homepage
    console.warn(`The href "${url}" was not found in the configuration or excludedDynamicPageRoutes`);
    this.router.navigate([this.homepageRoute]);

    return null;
  }

  private tryGetHomepage(pages: PageModel[]): PageModel | undefined {
    return pages.find(page => page.pageType === PageType.HOME);
  }

  private tryGetPageFromRoute(siteConfig: SiteConfig, pages: PageModel[], formattedUrl: string): PageModel | undefined {
    const navigation = siteConfig.navigation.siteNavigationItems.find(item => item.navigationUrl === formattedUrl) as any

    if (navigation) {
      return pages.find(page => page.id === navigation.pageId);
    }

    return undefined; // do something here
  }
}
